import { Component, inject, Input } from '@angular/core';
import { AuthService, LinksService } from '@isophi/core-legacy';


type InfoBannerType = 'demo' | 'trial' | 'trial-expired' | 'license-expiring' | 'license-expired';

@Component({
    selector: 'app-info-banner',
    templateUrl: './info-banner.component.html',
    styleUrls: ['./info-banner.component.scss'],
    standalone: false
})
export class InfoBannerComponent {
  protected readonly authService = inject(AuthService);

  private readonly linksService = inject(LinksService);

  @Input() type: InfoBannerType = 'trial';

  @Input() hasTestKit = false;

  @Input() daysLeft?: number;

  get canRenew(): boolean {
    return !!(this.authService.loggedUser?.teacher?.isDirector() || this.authService.loggedUser?.teacher?.isManager());
  }

  /**
   * Redirect user to the management application price list.
   */
  handleRedirectToPriceList(): void {
    window.location.href = this.linksService.getManagementAppUrl({ redirect: '/settings/price-list' }).url;
  }
}
